// Status options for tasks
export const TASK_STATUSES = ['TODO', 'IN_PROGRESS', 'REVIEW', 'DONE'];

// Status option objects for dropdowns
export const TASK_STATUS_OPTIONS = [
  { value: 'TODO', id: 'TODO' },
  { value: 'IN PROGRESS', id: 'IN_PROGRESS' },
  { value: 'REVIEW', id: 'REVIEW' },
  { value: 'DONE', id: 'DONE' },
];

// Color constants for DoD status
export const LIGHT_ORANGE = "#ffb74d";
export const GREEN = "#32cd32"; // limegreen
export const GREY = "#808080";

// Default values
export const DEFAULT_CATEGORY_WIDTH = 110;
export const MAX_CATEGORY_WIDTH = 200;
export const DEFAULT_TASK_TITLE_WIDTH = 100;
export const MIN_TASK_TITLE_WIDTH = 50;

// Keyboard shortcut display
export const getKeyboardShortcutDisplay = () => {
  return navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? "⌘" : "ctrl";
};

